<template>
    <div class="audio-content shadow-more">
        <!-- 左边 -->
        <div class="audio-content-left"
             v-loading="waveLoading"
             element-loading-background="#f9fbfe"
             element-loading-text="载入音频中……"
        >
          <div class="audio-content-left-head">
            <button class="example-btn" @click="getExample(0)">样例1</button>
            <button class="example-btn" @click="getExample(1)">样例2</button>
            <button class="example-btn" @click="getExample(2)">样例3</button>
          </div>
            <!-- 左边-内容区 -->
            <template  v-if="audioUrl">
              <div  class="audio-content-left-pic">
                <div  class="audio-content-left-pic-audio">
                  <div  class="audio-content-left-pic-audio-title">
                    <img src="@/assets/icon/podcast.png" alt="icon" class="nav-icon"> 音频文件.mp3
                  </div>
                  <div  class="audio-content-left-pic-audio-content" ref="audioarea">
                  </div>
                </div>
                <div class="audio-content-left-pic-text">
                  <div  class="audio-content-left-pic-text-title">
                    <img src="@/assets/icon/news.png" alt="icon" class="nav-icon"> 语音转文本
                  </div>
                  <div  class="audio-content-left-pic-text-content">


                    <div v-if="audioText==null">
                      <el-skeleton animated :rows="0"></el-skeleton>
                    </div>
                    <div v-else-if="audioText.length>0"  class="text-content-right-down-list">
                      <el-collapse accordion>
                        <el-collapse-item v-for="(item,index) in audioText" :key="index">
                          <template slot="title">
                            <div class="text-content-right-down-list-item" >
                              <div style="display: flex;align-items: center">
                      <span class="content"
                      style="color:#606266;
                      font-size:14px">
                        {{item.text}}
                      </span>

                                <div class="redius-shadow ">
                                  <img  class="sound" @click="playforIndex(item.start,item.end)" src="@/assets/pic/sound.png" style="height: 30px;object-fit: contain">

                                </div>


                              </div>
                            </div>
                          </template>
                          <div style="padding: 0 10px;font-size: 15px;display: flex;flex-direction: column">

                            <div class="flex" style="border-top: #97b2e9 1px solid;">
                              <div style="width: 10%;margin-right: 5px"><strong >时段:</strong></div>    <div >{{item.start}}s - {{item.end}}s</div>
                            </div>
                            <div class="flex" >
                              <div style="width: 10%;margin-right: 5px"><strong >文本:</strong></div>    <div style="width: 85%">{{item.text}}</div>
                            </div>

                          </div>
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                    <div v-else style="padding: 20px">
                      <el-skeleton  animated :rows="3"></el-skeleton>
                    </div>

                  </div>
                </div>
              </div>
            </template>
            <template v-else>
                <div
                    class="audio-content-left-content"
                    @dragover.prevent @drop.prevent="handleDrop"
                    @click="openFileInput"

                >
                  <div style="height: 100px">
                    <!-- <svg class="icon" aria-hidden="true"> -->
                      <!-- <use xlink:href="#icon-yinle"></use> -->
                    <!-- </svg> -->
                     <img style="height: 100%;object-fit: contain" src="@/assets/icon/upload.png">
                  </div>
                    <span style="font-size:16px; color:#909399;margin-bottom: 5px">请点击或拖拽上传音频(大小限制为5MB，时长不超过10分钟)</span>
                    <span style="font-size:16px; color:#909399;padding: 0 10px;">仅支持音频格式为：wav、mp3、m4a、wma、ogg</span>
                    <span style="font-size:16px; color:#909399">
                    </span>
                    <input ref="fileInput" type="file"
                        accept="audio/wav, audio/mp3, audio/amr, audio/m4a, audio/wma, audio/ape, audio/ogg"
                        class="file-input" style="display: none" @change="previewAudio" />
                </div>
            </template>
            <!-- 左边-底部 -->
            <div class="audio-content-left-footer">
                <div class="audio-content-left-footer-button">
                  <div class="audio-content-left-footer-button-left">
                    <button class="delete-btn" @click="clearAudio()">
                      <img src="@/assets/icon/delete.png" alt="icon" class="delete-icon">
                    </button>
                  </div>
                  <div class="audio-content-left-footer-button-middle"></div>
                  <div class="audio-content-left-footer-button-right">
                    <button class="analysis-btn" @click="anlaData()">音频分析</button>
                  </div>
                </div>
            </div>
        </div>
        <!-- 右边 -->
      <template v-if="loading!==null">
        <div class="audio-content-right"
             v-loading="loading"
             element-loading-background="#f9fbfe"
             element-loading-text="风险内容检测中……"
        >

          <template v-if="loading===false">
                <!-- 右边-上方 -->
                <div class="audio-content-right-up">
                    <div class="audio-content-right-up-text">
                        <div class="audio-content-right-text-up">
                          <el-alert
                            v-if="aiScore < 50"
                            description="你输入的内容AI生成可能性低"
                            type="success"
                            center
                            :closable="false"
                            show-icon>
                          </el-alert>
                          <el-alert
                            v-if="aiScore >= 50"
                            description="你输入的内容似乎是由AI生成的"
                            type="warning"
                            center
                            :closable="false"
                            show-icon>
                          </el-alert>
                        </div>
                        <div class="audio-content-right-text-down">
<!--                          <countTo :startVal='0' :endVal='resultData.power' :suffix='"%"' :duration='600'></countTo>-->
<!--                          <countTo :class="{text_transition:this.resultData.power>70}" :startVal='0' :endVal='resultData.power' :suffix='"%"' :duration='600'></countTo>-->
                          <CircleProgress :size="120" :progress="aiScore"></CircleProgress>

                        </div>
                    </div>
                </div>
              <!-- 右边-下方 -->
              <div class="audio-content-right-down summary">

                  <div class="audio-content-right-down-title">音频包含文本风险信息：</div>
                  <el-skeleton v-if="this.noRisk==null" animated :rows="4"></el-skeleton>
                <el-alert
                    v-if="noRisk"
                    style="margin-top: 10px"
                    title="音频不包含风险内容"
                    type="success"
                    center
                    :closable="false"
                    show-icon>
                </el-alert>
                  <div v-if="noRisk === false" class="text-content-right-down-list" style="overflow-y: hidden">
                    <el-collapse accordion>
                      <el-collapse-item v-for="(risk,index) in modelresult" :key="index">
                        <template slot="title">
                          <div class="text-content-right-down-list-item" :style="{ animationDelay: (index * 0.15) + 's' }">
                            <div style="display: flex;align-items: center">
                      <span class="content"
                      style="color:#606266;
                      font-size:14px">
                        {{risk.text}}

                      </span>

                                <img  class="sound" @click="playforIndex(risk.start,risk.end)" src="@/assets/pic/sound.png" style="height: 30px;object-fit: contain">


                            </div>
                            <span class="tag">
                    <el-tag type="danger">{{ risk.risk_type }}</el-tag>
                  </span>
                          </div>
                        </template>
                        <div style="padding: 0 10px;font-size: 15px;display: flex;flex-direction: column">

                          <div class="flex" style="border-top: #97b2e9 1px solid;">
                            <div style="width: 20%;margin-right: 5px"><strong >文本:</strong></div>    <div style="width: 80%">{{risk.text}}</div>
                          </div>
                          <div class="flex">
                            <div style="width: 20%;margin-right: 5px"><strong >风险类型:</strong></div>    <div>{{risk.risk_type}}</div>

                          </div>
                          <div class="flex">
                            <div style="width: 20%;margin-right: 5px"><strong >恶意程度:</strong></div>    <div>{{risk.malicious_degree}}</div>

                          </div>

                          <div style="margin-top: 5px">{{risk.analysis}}</div>
                        </div>

                      </el-collapse-item>


                    </el-collapse>

                    <!--              <div v-for="(item, index) in resultData.list" :key="index">-->
                    <!--                <div class="text-content-right-down-list-item" :style="{ animationDelay: (index * 0.15) + 's' }">-->
                    <!--                  <span class="content">{{ item.content }}</span>-->
                    <!--                  <span class="tag">-->
                    <!--                    <el-tag type="danger">{{ item.type }}</el-tag>-->
                    <!--                  </span>-->
                    <!--                </div>-->
                    <!--              </div>-->
                    <!--              <feedback-btns icontype="iconfont icon-copy"></feedback-btns>-->

                  </div>

<!--                  <div class="audio-content-right-down-list">-->
<!--                    <div v-for="(item, index) in resultData.messageList" :key="index">-->
<!--                      <div class="audio-content-right-down-list-item" :style="{ animationDelay: (index * 0.15) + 's' }">-->
<!--                        <span class="time"> {{ item.time }} </span>-->
<!--                        <span class="content"> {{ item.content }} </span>-->
<!--                        <img  class="sound" @click="playforIndex(item)" src="@/assets/pic/sound.png" style="height: 30px;object-fit: contain">-->
<!--                        <span class="label">-->
<!--                           <el-tag type="danger">{{ item.label }}</el-tag>-->
<!--                         </span>-->
<!--                      </div>-->
<!--                    </div>-->
<!--&lt;!&ndash;                    <feedback-btns style="margin-top: 10px" icontype="iconfont icon-copy"></feedback-btns>&ndash;&gt;-->


<!--                  </div>-->

<!--                <template v-else-if="resultData.type === 'success'">-->
<!--                  <div class="audio-content-right-down-success"><span>检测内容正常</span></div>-->
<!--                </template>-->
              </div>
          </template>
        </div>
      </template>
    <template v-if="loading===null">
        <div class="audio-content-right-init">
            <img src="@/assets/icon/robot.png" alt="icon" class="robot-icon">
            <span class="audio-content-right-init-text">检测结果将显示在这里</span>
        </div>
    </template>
    </div>
</template>

<script>
import countTo from 'vue-count-to';
import feedbackBtns from "@/components/feedbackBtns.vue";

import WaveSurfer from 'wavesurfer.js'
import CircleProgress from "@/components/CircleProgress.vue";


export default {
    components: {CircleProgress, countTo,feedbackBtns },
    data() {
        return {
          modelresult:[],
          audioText:null,
          waveLoading:false,
          aiScore:0,
          loading:null,
          noRisk:null,
            audioUrl: '',
            selectedFile:null,
            resultData: {},
          wavesurfer:null,
            isAudios: false,
          samAudios:[
              require('@/assets/testAudios/1-harm.mp3'),
              require('@/assets/testAudios/2-ai-noharm.mp3'),
              require('@/assets/testAudios/3-no-ai-no-harm.mp3'),

          ],
            textErrorSrc: require('@/assets/pic/error-robot.svg'),
            textSuccessSrc: require('@/assets/pic/text-success.png'),

          colors: [

            {color: '#5cb87a', percentage: 40},
            {color: '#e5ca6f', percentage: 60},

            {color: '#ce5252', percentage: 80},
            {color: '#ec4c4c', percentage: 90},
            {color: '#f84141', percentage: 100}
          ],
        }
    },
    methods: {

      waveform(){

        if(this.wavesurfer){
          this.wavesurfer.destroy()
          this.wavesurfer=null
        }

        this.$nextTick(()=>{
          const options = {
            /** HTML element or CSS selector (required) */
            container: this.$refs.audioarea,
            /** The height of the waveform in pixels */
            height: 40,
            /** The width of the waveform in pixels or any CSS value; defaults to 100% */
            width: 400,
            /** Render each audio channel as a separate waveform */
            splitChannels: false,
            /** Stretch the waveform to the full height */
            normalize: false,
            /** The color of the waveform */
            waveColor: '#3c54f1',
            /** The color of the progress mask */
            progressColor: '#b361ea',
            /** The color of the playpack cursor */
            cursorColor: '#731ee1',
            /** The cursor width */
            cursorWidth: 2,
            /** Render the waveform with bars like this: ▁ ▂ ▇ ▃ ▅ ▂ */
            barWidth: 6,
            /** Spacing between bars in pixels */
            barGap: 4,
            /** Rounded borders for bars */
            barRadius: 14,
            /** A vertical scaling factor for the waveform */
            barHeight: 1,
            /** Vertical bar alignment **/
            barAlign: '',
            /** Minimum pixels per second of audio (i.e. zoom level) */
            minPxPerSec: 50,
            /** Stretch the waveform to fill the container, true by default */
            fillParent: true,
            /** Audio URL */
            url: this.audioUrl,
            /** Whether to show default audio element controls */
            mediaControls: true,
            /** Play the audio on load */
            autoplay: true,
            /** Pass false to disable clicks on the waveform */
            interact: true,
            /** Allow to drag the cursor to seek to a new position */
            dragToSeek: true,
            /** Hide the scrollbar */
            hideScrollbar: true,
            /** Audio rate */
            audioRate: 1,
            /** Automatically scroll the container to keep the current position in viewport */
            autoScroll: true,
            /** If autoScroll is enabled, keep the cursor in the center of the waveform during playback */
            autoCenter: true,
            /** Decoding sample rate. Doesn't affect the playback. Defaults to 8000 */
            sampleRate: 8000,
          }

          this.wavesurfer = WaveSurfer.create(options)

          this.wavesurfer.on('ready', () => {
            this.waveLoading = false
            this.wavesurfer.setTime(0)
            // this.playFromTo(10,20)
          })

          this.wavesurfer.on('error', (e) => {
            console.error('Waveform loading error:', e);
            this.waveLoading = false; // 发生错误时设置loading为false
          });


        })
        // this.waveLoading = false

      },
      playforIndex(start,end){
        this.playFromTo(start,end)
      },

        openFileInput() {
          this.$refs.fileInput.click();
        },
        previewAudio(event) {
            const file = event.target.files[0];
            this.selectedFile = file;
            const reader = new FileReader();
            this.waveLoading = true
            reader.onload = (e) => {
                this.audioUrl = e.target.result;
                this.waveform()

            };
            reader.readAsDataURL(file);

            // 清除文件输入框的值，避免浏览器缓存
            event.target.value = '';
        },
      handleDrop(event) {
        this.waveLoading = true
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type.startsWith('audio/')) {
          this.selectedFile = file;
          const reader = new FileReader();
          reader.onload = (e) => {
            this.audioUrl = e.target.result;
            this.waveform()
          };
          reader.readAsDataURL(file);
        }else {
          this.$message.error("请上传支持的音频格式文件")
          this.waveLoading = false

        }
      },
      playFromTo(startTime, endTime) {
        if (!this.wavesurfer) {
          console.error('WaveSurfer instance is not initialized.');
          return;
        }
        this.wavesurfer.unAll()


        this.wavesurfer.setTime(startTime)
          this.wavesurfer.play(startTime);
          this.wavesurfer.on('audioprocess', () => {
            const currentTime = this.wavesurfer.getCurrentTime();
            if (currentTime >= endTime) {
              this.wavesurfer.pause();
              this.wavesurfer.setTime(startTime);
              this.wavesurfer.unAll(); // 移除监听器
            }
          });

      },
      async uploadFile() {

        if (!this.selectedFile) {
          this.$message.warning('请先选择所需上传的文件');
          return;
        }
        try {
          this.loading = true
          // 使用 await 等待异步操作完成
          let timestamp = Date.now();
          const additionalData = { type: 'audio', timestamp: timestamp };
          const resFile = await this.apis.uploadFile(this.selectedFile, additionalData);
          console.log(resFile.data.message);
          if (resFile.data.message === '文件上传成功') {
            this.$message.success('文件上传成功');
            this.audioAnalysis(timestamp);
          }
        } catch (error) {
          this.$message.error('文件上传失败');
          console.error('上传失败:', error);
          this.loading = false
        } finally {
          // this.loading = false
          this.fileLoading = false;
        }
      },

      //文件分析
      audioAnalysis(timestamp) {



        this.apis.audioAIDetect({
          type: 'audio',
          fileName: this.selectedFile.name,
          fileTimestamp: timestamp
        })
            .then(res => {
              console.log(res)
              setTimeout(()=>{
                this.aiScore = Math.floor(Number(res.score) * 1000) / 10;
              },500)

              // console.log(this.aiScore)

            })
            .catch(err => {
              console.log()
              // this.loading = false
              this.$notify.error({
                title: '系统错误，请联系管理员。',
                message: err
              });
            })
            .finally(()=>{
              this.loading = false
            });

        this.audioText = []
        this.apis.audio2text({
          type: 'audio',
          fileName: this.selectedFile.name,
          fileTimestamp: timestamp
        })
            .then(res => {
              console.log(res)
              this.audioBigModel(res.file_path)
              this.audioText = JSON.parse(res.text)
              console.log(this.audioText)


            })
            .catch(err => {
              console.log()
              // this.loading = false
              this.$notify.error({
                title: '语音转文本接口出错',
                message: err
              });
            })
            .finally(()=>{

            });
      },
      async anlaData() {
        await this.uploadFile();
      },


        getExample(index) {
        this.clearAudio()
        this.waveLoading = true

    this.audioUrl =this.samAudios[index]
    this.waveform()
    fetch(this.audioUrl)
      .then(response => response.blob())
      .then(blob => {
        const file = new File([blob], 'audio.mp3', { type: 'audio/mp3' });
        this.selectedFile = file;
        this.anlaData(); // 在获取文件成功后,手动调用anlaData方法
      })
      .catch(error => {
        console.error('Error fetching the audio file:', error);
      });
  },
      audioBigModel(file_path){
        console.log(file_path)
        this.apis.modelResult({
          name: "audioRiskDetect",
          filePaths: file_path,
        })
            .then(res => {
              console.log(res)
              this.modelresult =JSON.parse(res.result)
              this.noRisk = this.modelresult.length === 0;
              console.log( this.modelresult)
            })
            .catch(err => {
              console.log()
              this.$notify.error({
                title: '系统错误，请联系管理员。',
                message: err
              });
            });
      },
        clearAudio() {
           this.audioText = null
            this.audioUrl = ''
          this.modelresult = []
          this.aiScore = 0
          this.loading = null
          this.noRisk = null
          if (this.wavesurfer) {
            this.wavesurfer.destroy()
            this.wavesurfer = null
          }
            //演示案例
            this.resultData = {};
        },
    },
    computed: {

    },
}
</script>

<style>
.audio-content {
    display: flex;
    height: 65vh;
    background-color: #F9FBFE;
    width: 77vw;
  border-radius: 35px;
    padding: 20px;
}

.el-loading-spinner .el-loading-text  {
  font-size: 20px ;

}
.audio-content-left {
  border-right: 1px solid #91aee8;
  padding:0 10px;
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
}

.audio-content-left-head {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 8%;
  margin-bottom: 5px;
  margin-top: 5px;
}

.audio-content-left-pic {
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    flex-direction: column;
}

.audio-content-left-pic-audio {
    flex:2;
    border: 1px solid #91aee8;
    width: 99%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-bottom: 6px;
    justify-content: center;
    align-items: center;
}

:host audio {
  height: 10px !important; /* 你想要设置的高度 */
}

.audio-content-left-pic-audio-title{
  flex:1;
  border-bottom: 1px solid #91aee8;
  display: flex;
  align-items: center;
  width: 95%;
}

.audio-content-left-pic-audio-content{
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  flex:4;
}



.audio-content-left-pic-text {
    flex:3;
    border: 1px solid #91aee8;
    width: 99%;
    display: flex;
    align-items: center;
    flex-direction: column;
    overflow-y:auto;
    margin-top: 6px;
}

.audio-content-left-pic-text::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.audio-content-left-pic-text::-webkit-scrollbar-track {
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(139, 139, 139, 0.3);
}

.audio-content-left-pic-text::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-radius: 6px;
  background: rgba(101, 102, 104, 0.5);
  -webkit-box-shadow: inset 0 0 6px rgba(20, 20, 20, 0.3);
}
.audio-content-left-pic-text-title{
  flex:1;
  border-bottom: 1px solid #91aee8;
  display: flex;
  align-items: center;
  width: 95%;
}

.audio-content-left-pic-text-content{
  flex:6;
  width:100%;
}
.audio-content-left-content {
  height: 80%;
  width: 100%;
  border: 1px #c0c4cc dashed;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;

}

.file-input {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: auto;
    /* 调整为自动宽度 */
    height: 100%;
    /* 调整高度以匹配按钮 */
    opacity: 0;
    cursor: pointer;
}

audio {
    width: 100%;
    margin: 0 auto;
    display: block;
    background-color: #f2f2f2;
    padding: 10px;
    border-radius: 20px;
}

.audio-content-left-footer {
  display: flex;
  align-items: center;
  height: 10%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
}

.audio-content-left-footer-button {
  height: 100%;
  width:100%;
  display: flex;
  flex-direction: row;
}

.audio-left-text {
  display: flex;
  /* border: 1px solid; */
  flex-direction: column;
}

.audio-content-left-footer-button-left{
  height: 100%;
  flex:1;
  display:flex;
  align-items: center;
  border-radius: 100px;
  transition: background-color ease 0.15s;
}
.audio-content-left-footer-button-left:hover {
  background-color: #e4e7eda3;
}
.audio-content-left-footer-button-middle{
  height: 100%;
  flex:4;
}

.audio-content-left-footer-button-right{
  height: 100%;
  flex:4;
  display:flex;
  align-items: center;
}



.audio-content-right {
  padding: 10px;
  height: 95%;
  width: 50%;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  overflow-y: auto;
}

.audio-content-right::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.audio-content-right::-webkit-scrollbar-track {
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(139, 139, 139, 0.3);
}
.audio-content-right::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-radius: 6px;
  background: rgba(101, 102, 104, 0.5);
  -webkit-box-shadow: inset 0 0 6px rgba(20, 20, 20, 0.3);
}

.audio-content-right-init{
  display: flex;
  flex-direction: column;
  height:80%;
  width:50%;
  justify-content: center;
  align-items: center;
}

.audio-content-right-init-text{
  font-weight: bold;
  color:#c3c7d6;
}

.audio-content-right-up {
    height: 40%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  margin-bottom: 20px;

}


.audio-content-right-up-text {
    display: flex;
    align-items: center;
    flex-direction:column;
}

.audio-content-right-text-up {
    font-size: 25px;
    font-weight: bolder;
}

.audio-content-right-text-down {
    margin-top: 15px;

  font-weight: bolder;
}

.audio-content-right-down {
    //flex: 3;
    display: flex;
    flex-direction: column;
    //overflow:hidden;
}

.audio-content-right-down-title {
  margin: 10px 0;
  font-size: 17px;
  font-weight: bolder;
  padding-bottom: 16px;
  border-bottom: 1px solid #91aee8;
}

.audio-content-right-down-list {
  height: 40vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.audio-content-right-down-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 4vh;
  font-size: 13px;
  background-color: #fef0f040;
  padding: 10px;
  /* 调整文字与边框的距离 */
  border: 1px solid #f56c6c;
  /* 调整边框颜色 */
  border-radius: 5px;
  /* 圆角 */
  margin: 10px 0;
  overflow: hidden;
  opacity: 0;
  transform: translateX(50px);
  animation: fadeIn 0.5s forwards;
}

.audio-content-right-down-list-item .time {
  flex: 4;
  align-items: center;
}

.audio-content-right-down-list-item .content {
  flex: 5;
  overflow:auto;
}

.audio-content-right-down-list-item .content ::-webkit-scrollbar {
  width: 6px;
  height: 10px;
}
.audio-content-right-down-list-item .content::-webkit-scrollbar-track {
  border-radius: 1px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(139, 139, 139, 0.3);
}

.audio-content-right-down-list-item .content::-webkit-scrollbar-thumb {
  background-clip: content-box;
  border-radius: 6px;
  background: rgba(101, 102, 104, 0.5);
  -webkit-box-shadow: inset 0 0 6px rgba(20, 20, 20, 0.3);
}

.audio-content-right-down-list-item .sound {
  flex: 2;
  align-items: center;
  cursor: pointer;
}

.audio-content-right-down-list-item .label {
  flex: 2;
  align-items: center;
}

@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.audio-content-right-down-success {
    height: 100%;
    font-size: 35px;
    font-weight: 500;
    margin: 50px 0 0 20px;

}
</style>
